import React from 'react';
import { HighlightedSearchContext } from '../../../../context';
import { useSearchTerm } from '../../../../hooks';

export const SchemaEntitiesSearch: React.FC = ({ children }) => {
  const [search, handleSearch] = useSearchTerm();

  return (
    <div className="sql-schema-nav">
      <div className="schemaTitleContainer">
        <h4>Schema Navigator</h4>
        <input
          placeholder="Search tables and columns"
          type="text"
          className="form-control"
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>
      <div className="sql-schema-nav-body">
        <div className="schemaBodyContent">
          <HighlightedSearchContext.Provider value={search}>
            {children}
          </HighlightedSearchContext.Provider>
        </div>
      </div>
    </div>
  );
};
